// extracted by mini-css-extract-plugin
export default {"mainContainer":"EnterAuthorizationCode_mainContainer__JsQ9o","buttonsContainer":"EnterAuthorizationCode_buttonsContainer__rxXRY","form":"EnterAuthorizationCode_form__xnp+Q"};